/* Copyright 2013 - 2024 Waiterio LLC */
export default async function getHls() {
  return import(/* webpackChunkName: 'hls' */ 'hls.js/dist/hls.light.min.js')
    .then(({ default: Hls }) => Hls)
    .catch(console.error)
}
